import { Endpoint, Http } from "Application";
import { AppUrls } from "AppUrls";

export interface IDeleteMentorStudentRequest {
    id: Guid;
    studentSessionId: Guid;
    startDate: any;
    isAbsence?: boolean;
}

export class DeleteMentorStudentEndPoint extends Endpoint<IDeleteMentorStudentRequest, Response> {
    constructor() {
        super();
        this.verb(Http.Delete);
        this.path(AppUrls.Server.WeeklyRota.DeleteMentorRotaAbsence);
    }

    public async HandleRequestAsync(request: IDeleteMentorStudentRequest): Promise<IDeleteMentorStudentRequest> {
        return Promise.resolve(request);
    }

    public async HandleResponseAsync(responses: Response[]): Promise<any> {
        return Promise.resolve(responses);
    }
}
